import { render } from "./MemberDashboardDesktop.vue?vue&type=template&id=3b61b6e3&scoped=true"
import script from "./MemberDashboardDesktop.vue?vue&type=script&lang=js"
export * from "./MemberDashboardDesktop.vue?vue&type=script&lang=js"

import "./MemberDashboardDesktop.vue?vue&type=style&index=0&id=3b61b6e3&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b61b6e3"]])

export default __exports__